// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__rRtBW","wrapperHeaders":"styles_wrapperHeaders__iK6ex"};